/* Package JSON Import will be here */
import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import _, { isEqual } from 'lodash';
import * as moment from 'moment';
/* Package JSON Import will be here */

/* Project Import will be here */
import TimeCardComponent from '../timeCard/timeCard.Component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import * as utility from '../../services/utility';
import * as actions from '../../actions/login.Action';
import * as dateActions from '../../actions/date.Action';
import * as timeCardActions from '../../actions/timeCardDatas.Action';
import { MessageBox } from '../../scenes/sharedComponent/messageBox';
import { configSettings } from "../../config/configSettings";
import * as onDefaultGroupByAction from '../../actions/timecardDefaultGroupBy.Action';
import * as onHistorySaveAction from '../../actions/history.Action';
import * as tmVoucherAction from "../../actions/tmVoucher.Action";
import { CheckEnterHours, EmptyAttestDetails } from './Attestation/AttestationUtils';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class TimeCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeRecords: [],
            isIssueNoteModalVisible: false,
            selectedDate: new Date(this.props.date.selectedDate),
            selectedPayRollNote: {},
            savedPayRollNote: {},
            isOpenPayRollNotes: false,
            isOpenActualNotes: false,
            isOpenExceptationalNotes: false,
            isAttachmentModelVisible: false,
            selectedAttachment: "",
            isShowActualModalLoading: false,
            weekStartDate: null,
            weekEndingDate: null,
            isOpenTimeCardReview: false,
            defaultGroupBy: Constants.EMPLOYEE,
            isGroupByModelVisible: false,
            payRollNoteListOptions: [],
            isShowPayRollNoteSaveConfimation: false,
            selectedExpectationsNote: {},
            savedExpectationsNote: {},
            isShowExpectationNoteSaveConfimation: false,
            selectedActualNote: {},
            savedActualNote: {},
            isShowActualNoteSaveConfirmation: false,
            selectedIssueNotes: [],
            savedIssueNotes: [],
            issueNotesCount: 0,
            isDeleteConfirmationPopupVisible: false,
            isDeleteIconClicked: false,
            selectedTimeRecordsForDelete: [],
            isSelectPastDate: false,
            isShowLoader: false,
            isSubmitConfirmationModelVisible: false,
            isSubmitConfirmationMessage: "",
            submittedTimeRecordCount: 0,
            submittedIssueNoteCount: 0,
            isSubmitModelVisible: false,
            isSubmitIssueNoteModelVisible: false,
            totalTimeCardList: [],
            isIssueNoteVisible: true,
            isShowIssueNoteSaveConfirmation: false,
            isSaveIssueNoteButtonDisabled: false,
            statusCodeOptions: [],
            statusCodeDataList: [],
            statusCodeList: [],
            selectDate: '',
            dateSelected: '',
            dailyDetailsCount: 0,
            isDatePickerOpen: false,
            isLoggedIn: true,
            isHaveDupicateTimeRecord: false,
            isShowTMVoucher: this.props.history?.location?.state?.isOpenSelectTaskCode ?? false,
            tmTaskCodeList: [],
            selectedTMVoucher: {},
            tmVouchersCount: 0,
            tmVoucherConfirmMessage: '',
            isTimeCardHasTMCode: false,
            timeCardSubmittedMessage: "",
            issueNoteSubmittedMessage: "",
            taskCodeIdAndProjectIdWithTMCode: [],
            isTMVoucherSubmitted: false,

            rejectedAttestationEmployeeList: [],
            isRejectedAttestation: false,
            isShowAttestationErrorModal: false,
            attestErrorValidationMessage: "",
            isAllowAttestation: false,
            isShowTimeCardError: false,
            validationTimeRecordIdsWithTypes: [],
            isActualNoteSaveBtnDisabled: false
        };
    }

    componentDidMount() {
        let { isIssueNoteVisible } = this.state;
        var datePicked = new Date(this.state.selectedDate);
        var currentDate = moment(new Date()).format("MM/DD/YYYY");
        var dateSelected = moment(datePicked).format("MM/DD/YYYY");
        isIssueNoteVisible = dateSelected <= currentDate ? true : false;
        this.setState({ isIssueNoteVisible });

        this.props.onHistorySave(window.location.pathname);
        this.props.setTmVoucherModelVisibility(false);
        window.addEventListener('beforeunload', () => {
            this.props.groupByInTimecardPage('');
            if (!this.state.isLoggedIn) {
                this.props.logout();
            }
        });
        //TODO: #BUG 363 NEED TO FIND THE ALTERNATIVE WAY FOR THIS CODE
        window.addEventListener('storage', () => {
            let reduxState = JSON.parse(localStorage.getItem('reduxState'));
            if (reduxState && reduxState.loginReducer && reduxState.loginReducer.user && !reduxState.loginReducer.user.loggedIn) {
                this.setState({ isLoggedIn: false })
            }
        })
    }

    componentWillMount() {
        let { defaultGroupBy } = this.state;
        let isFromLogin = this.props.history?.location?.state?.isFromLogin ?? false;
        if (!isFromLogin) {
            this.checkEmployeeAccess();
        }
        if (this.props.groupBy.timeCardGroupBy && this.props.groupBy.timeCardGroupBy === Constants.PROJECT) {
            defaultGroupBy = this.props.groupBy.timeCardGroupBy;
        }
        if (window.location.pathname === "/TimeCard") {
            window.history.pushState(null, null, window.location.href);
            window.onpopstate = function (e) {
                e.preventDefault();
                window.history.go(1);
            };
        }
        this.DeleteUnassignedAndInactiveProjectTimecards();
        this.getStatusCodeList();
        this.getIssueNotesAndDailyDetailsAndTMVouchersCount();
        this.getTMVoucherTaskCodes();
        this.props.onDefaultGroupBy('');
        this.setState({ defaultGroupBy })
    }

    componentWillUnmount() {
        window.onpopstate = () => { };
    }

    checkEmployeeAccess() {
        let url = ApiUrls.Routes.ACNT_C + ApiUrls.Routes.WNDS_LN_M + `?deviceFingerPrintId=${this.props.device.deviceFingerPrintId}&employeePin=${this.props.user.employeeNumber}`;
        Api.Get(url, this).then((responseData) => {
            if (!responseData.success) {
                this.onClickLogout();
            }
        });
    }

    DeleteUnassignedAndInactiveProjectTimecards() {
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.DL_UA_AND_IA_TMC}?deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.getTimeCardData();
                var current = new Date();
                var monday = (new Date(current.setDate(current.getDate() - current.getDay() + (current.getDay() == 0 ? -6 : 1))));
                var sunday = (new Date(current.setDate(current.getDate() - current.getDay() + 7)));
                this.setState({
                    weekEndingDate: sunday, weekStartDate: monday
                }, () => { this.getIssueNotesAndDailyDetailsAndTMVouchersCount(); this.getTMVoucherTaskCodes(); });
            }
        });
    }

    getTimeCardData(date = null, isFromGroupByOptionMethod = false, isFrom = null) {
        let { defaultGroupBy, timeRecords, isIssueNoteVisible, isHaveDupicateTimeRecord, isShowTimeCardError, selectedTimeRecordsForDelete } = this.state;
        var datePicked = date != null ? new Date(date) : new Date(this.state.selectedDate);

        var currentDate = moment(new Date()).format("MM/DD/YYYY");
        var dateSelected = moment(datePicked).format("MM/DD/YYYY");
        isIssueNoteVisible = dateSelected <= currentDate ? true : false;

        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = date == null ? new Date(this.state.selectedDate) : new Date(date);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var selectedDate = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;
        timeRecords = [];

        const getUpdatedCurr = (curr) => {
            const isTimeCardSelectedForDelete = selectedTimeRecordsForDelete?.length > 0 && selectedTimeRecordsForDelete.some(a => a.TimerecordId === curr.timeRecordID);
            const updatedCurr = (isFrom === "Attestation")
                ? { ...curr, attestationStatus: curr.attestationStatus ?? "", checked: false }
                : { ...curr, attestationStatus: curr.attestationStatus ?? "", checked: isTimeCardSelectedForDelete };
            return updatedCurr;
        }

        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TME_CRD_DTE_RNG}?fromDate=${fromDate}&toDate=${toDate}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ isAllowAttestation: responseData.data.isAllowAttestation });
                var timeRecordData = responseData.data.timecardList;
                if (defaultGroupBy == Constants.EMPLOYEE) {
                    var groupByName = timeRecordData.reduce((prev, curr) => {
                        if (curr.employeeID) {
                            var previousData = prev.find(a => a.employeeID == curr.employeeID);
                            const updatedCurr = getUpdatedCurr(curr);
                            if (prev && previousData) {
                                previousData.timecardData = [...previousData.timecardData || [], updatedCurr];
                                previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                                previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                                previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                            }
                            else {
                                prev.push({
                                    employeeName: curr.fullName,
                                    employeeID: curr.employeeID,
                                    timecardData: [updatedCurr],
                                    totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                    totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                    totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                                });
                            }
                            return prev;
                        }
                        else {
                            prev = [];
                            return prev;
                        }
                    }, []);

                    timeRecords = groupByName;

                    this.setState({
                        timeRecords, isIssueNoteVisible, totalTimeCardList: responseData.data.timecardList, selectDate: fromDate, dateSelected: toDate, taskCodeIdAndProjectIdWithTMCode: responseData.data.taskCodeIdAndProjectIdWithTMCode ?? []
                    });
                } else {
                    var groupByProject = timeRecordData.reduce((prev, curr) => {
                        if (curr.projectID) {
                            var previousData = prev.find(a => a.projectID == curr.projectID);
                            const updatedCurr = getUpdatedCurr(curr);
                            if (prev && previousData) {
                                previousData.timecardData = [...previousData.timecardData || [], updatedCurr];
                                previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                                previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                                previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
                            }
                            else {
                                prev.push({
                                    employeeName: curr.fullName,
                                    employeeID: curr.employeeID,
                                    projectID: curr.projectID,
                                    projectNumber: curr.projectNumber,
                                    timecardData: [updatedCurr],
                                    totalStHours: Number(curr.stHours ? curr.stHours : 0),
                                    totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                                    totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                                });
                            }
                            return prev;
                        }
                        else {
                            prev = [];
                            return prev;
                        }
                    }, []);
                    let tableDataList = [];
                    groupByProject.map(a => {
                        a.timecardData.sort((b, c) => b.employeeNumber - c.employeeNumber);
                        tableDataList = tableDataList.concat(a.timecardData);
                    });

                    timeRecords = groupByProject;
                    this.setState({
                        timeRecords, isIssueNoteVisible, totalTimeCardList: tableDataList, selectDate: fromDate, dateSelected: toDate, taskCodeIdAndProjectIdWithTMCode: responseData.data.taskCodeIdAndProjectIdWithTMCode ?? []
                    });
                }
                if (isHaveDupicateTimeRecord) {
                    this.checkTimecardDuplicate();
                }
                if (isFromGroupByOptionMethod && isShowTimeCardError) {
                    this.validateTimeCardSubmit(true);
                }
            }
        });
    }

    getIssueNotesAndDailyDetailsAndTMVouchersCount() {
        let { selectedDate } = this.state;
        var datePicked = new Date(selectedDate);
        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(datePicked);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ISE_NT_CNT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ issueNotesCount: responseData.totalCount });
            } else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
        url = `${ApiUrls.Routes.DALY_DET_C}${ApiUrls.Routes.GT_DALY_DET_CNT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ dailyDetailsCount: responseData.totalCount });
            } else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
        url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_TM_VCHR_CNT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                this.setState({ tmVouchersCount: responseData.totalCount });
            } else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }

    getStatusCodeList() {
        let url = `${ApiUrls.Routes.FLDSTSCD_C}${ApiUrls.Routes.GT_A_FSCDLTWB_M}`;
        Api.Post(url, {}, this, false).then((responseData) => {
            if (responseData) {
                let statusCodeListOptions = responseData.data
                    .map((s) => {
                        return { key: s.id, text: s.statusInitial + "-" + s.displayText, value: s.id }
                    });
                this.setState(({
                    statusCodeDataList: [{ key: 0, text: "-Select-", value: 0 }, ...statusCodeListOptions],
                    statusCodeList: [{ key: 0, text: "-Select-", value: 0, id: 0 }, ...responseData.data]
                }));
            }
        });
    }

 getTimeCardIssue() {
     let { selectedDate, isSelectPastDate, projectList } = this.state;
     var datePicked = new Date(selectedDate);
     var startTime = new Date(datePicked.setHours(0, 0, 0));
     var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
     var tomorrow = new Date(datePicked);
     var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
     var endDate = new Date(endTime);
     endDate.setHours(0, 0, 0);
     var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
     var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
     var dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
     var timeZone = startDate.toString();
     var selectTimeZone = timeZone.slice(16, 24);
     this.getStatusCodeList();
     let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ISE_NT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}`;
     Api.Get(url, this, true, true).then(responseData => {
         if (responseData.success) {
             var issueNotesSaved = [];
             if (responseData.data.length > 0) {
                 let index = 0;
                 responseData.data.map(a => {
                     var attachmentList = [];
                     attachmentList = a.attachments;
                     attachmentList = attachmentList.sort((a, b) => a.attachmentId - b.attachmentId);
                     let attachmentIndex = 0;
                     attachmentList && attachmentList.length > 0 && attachmentList.map(attach => {
                         attach.index = attachmentIndex;
                         attachmentIndex = attachmentIndex + 1;
                         attach.Id = attach.attachmentId;
                         attach.AttachmentType = attach.attachmentType;
                         attach.AttachmentName = attach.attachmentName;
                         attach.AttachmentContent = attach.attachmentContent;
                         attach.IsActive = attach.isActive;
                     });
                     index += 1;
                     issueNotesSaved.push({
                         id: a.id,
                         issueNote: a.issueNote ? a.issueNote.toString() : '',
                         projectId: a.projectID,
                         projectNumber: a.projectNumber,
                         deviceId: a.deviceID,
                         createdDate: new Date(a.createdDate),
                         isDeleted: a.isDeleted,
                         attachment: attachmentList,
                         status: a.status,
                         submittedByEmployeeId: a.submittedByEmployeeId,
                         submittedDeviceName: a.submittedDeviceName,
                         index: index,
                         fieldStatusId: a.fieldStatusId,
                         fieldStatusInitial: a.fieldStatusInitial,
                         fieldStatusDescription: a.fieldStatusDescription,
                         lostHours: a.lostHours || ''

                     });
                 })
             }
             var selectedRow = [];
             if (!isSelectPastDate) {
                 selectedRow = issueNotesSaved.length > 0 ? issueNotesSaved : [{ id: 0, issueNote: '', projectId: 0, projectNumber: '', deviceId: this.props.device.deviceId, fieldStatusDescription: null, fieldStatusInitial: null, fieldStatusId: null, createdDate: null, isDeleted: false, attachment: [], status: Constants.ACTIVE, submittedByEmployeeId: null, submittedDeviceName: null, lostHours: '' }];
             }
             else if (isSelectPastDate && responseData.data.length > 0) {
                 selectedRow = issueNotesSaved.length > 0 ? issueNotesSaved : [];
             }
             let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPBDID_M}?deviceId=${this.props.device.deviceId}`;
             Api.Post(url, {}, this, true, true).then((responseData) => {
                 try {
                     if (responseData.success && responseData.data) {
                         projectList = responseData.data.sort((a, b) => b.projectNumber - a.projectNumber);
                         let projectListOptions = [];
                         projectList.map(a => {
                             projectListOptions.push({ key: a.id, text: a.projectNumber, value: a.id });
                         })
                         this.setState({
                             isIssueNotesModelVisible: true, selectedIssueNotes: selectedRow, savedIssueNotes: _.cloneDeep(selectedRow), isIssueSaveButtonDisabled: false, projectList: projectListOptions, isIssueNoteModalVisible: true, isShowLoader: false
                         });
                     }
                     else {
                         this.setState({ isShowLoader: false });
                         MessageBox(responseData.message, Constants.ERROR);
                     }
                 }
                 catch (err) {
                     this.setState({ isShowLoader: false });
                     MessageBox(err.message, Constants.ERROR);
                 }
             });
         } else {
             this.setState({ isShowLoader: false });
             MessageBox(responseData.message, Constants.ERROR);
         }
     });
 }

    onClickAddIssueNote() {
        let { selectedIssueNotes } = this.state;
        var data = { id: 0, issueNote: '', projectId: 0, projectNumber: '', fieldStatusId: 0, fieldStatusInitial: null, fieldStatusDescription: null, lostHours: '', deviceId: this.props.device.deviceId, createdDate: null, isDeleted: false, attachment: [], status: Constants.IN_PROGRESS, submittedByEmployeeId: null, submittedDeviceName: null };
        if (selectedIssueNotes) {
            selectedIssueNotes.push(data);
            this.setState({ selectedIssueNotes });
        }
    }

    onRemoveIssueNotes(index) {
        let { selectedIssueNotes } = this.state;
        var issueNote = selectedIssueNotes[index];
        if (issueNote.id === 0) {
            selectedIssueNotes.splice(index, 1);
        } else {
            issueNote.isDeleted = true;
        }
        this.setState({ selectedIssueNotes });
    }

    removeIssueNotesAttachment(index, attachmentIndex) {
        let { selectedIssueNotes } = this.state;
        var selectedIssueNote = selectedIssueNotes[index];
        var selectedIssueNotesAttachment = selectedIssueNote.attachment[attachmentIndex];
        if (selectedIssueNotesAttachment.Id > 0) {
            selectedIssueNotesAttachment.IsActive = false;
        } else {
            selectedIssueNote.attachment.splice(attachmentIndex, 1);
        }
        this.onChangeIssueNotesProjectDropDown(index, selectedIssueNote.attachment, 'attachment');
    }

    onChangeIssueNotesProjectDropDown(index, e, inputValue, isVoiceInput = false) {
        let { projectList, selectedIssueNotes, statusCodeList } = this.state;
        switch (inputValue) {
            case 'project':
                var project = projectList.find(t => t.value === e);
                selectedIssueNotes[index].projectNumber = project.text;
                selectedIssueNotes[index].projectId = project.key;
                break;
            case 'notes':
                selectedIssueNotes[index].issueNote = (isVoiceInput && selectedIssueNotes[index].issueNote) ? (selectedIssueNotes[index].issueNote + " " + e) : e.target.value;
                break;
            case 'statusCode':
                let statusCode = statusCodeList.find(a => a.id === e);
                if (e === 0) {
                    selectedIssueNotes[index].fieldStatusDescription = null;
                    selectedIssueNotes[index].fieldStatusInitial = null;
                    selectedIssueNotes[index].fieldStatusId = null;
                }
                else {
                    selectedIssueNotes[index].fieldStatusDescription = statusCode.displayText;
                    selectedIssueNotes[index].fieldStatusInitial = statusCode.statusInitial;
                    selectedIssueNotes[index].fieldStatusId = statusCode.id;
                }
                break;
            case 'lostHours':
                if (Constants.HOURS_REGEX.test(e.target.value)) {
                    let hour = e.target.value ? this.getHoursValue(e.target.value) : '';
                    selectedIssueNotes[index].lostHours = hour;
                }
                break;
            case 'attachment':
                selectedIssueNotes[index].attachment = e;
                let attachmentIndex = 0;
                selectedIssueNotes[index].attachment.map(attach => {
                    attach.index = attachmentIndex;
                    attachmentIndex = attachmentIndex + 1;
                });
        }
        this.setState({
            selectedIssueNotes, issueNotesList: selectedIssueNotes,isSaveIssueNoteButtonDisabled:false
        })
    }

    getHoursValue(e) {
        e = e.trim();
        let hourValue = e === '.' ? e : isNaN(e) ? 0 : e;
        let hour = (typeof (hourValue) === "string" && hourValue.replace(/[^\d\.*]+/g, '')) ? hourValue.replace(/[^\d\.*]+/g, '') : 0;
        hour = hour != 0 ? hour.replace(/^0+/, '') : hour == '0.' ? hour : '0';
        return hour;
    }

    closeIssueNotes(issue) {
        this.setState({
            isIssueNoteModalVisible: false,
            isShowIssueNoteSaveConfirmation: false
        })
    }

    onChangeIssueNoteAttachment = (images, index, savedAttachments) => {
        this.setState({ isSaveIssueNoteButtonDisabled: true }, () => {
            const attachments = savedAttachments ?? [];

            utility.maximumImageCheck(attachments, images).then((data) => {
                if (data.success) {
                    this.onChangeIssueNotesProjectDropDown(index, attachments, 'attachment');
                }
                else {
                    this.setState({ isSaveIssueNoteButtonDisabled: false });
                }
            });
        });
    }

    onSaveIssueNotesModel() {
        let { selectedIssueNotes, selectedDate } = this.state;
        this.setState({
            isSaveIssueNoteButtonDisabled: true
        }, () => {
            var requestData = [];
            var issueNoteWithInvalidHours = selectedIssueNotes.filter(t => t.lostHours > 24);
            if (issueNoteWithInvalidHours.length > 0) {
                MessageBox(Constants.LOST_HOURS_SHOULD_NOT_EXCEED, Constants.ERROR);
                this.setState({ isSaveIssueNoteButtonDisabled: false, isShowIssueNoteSaveConfirmation: false });
                return;
            }
            var data = selectedIssueNotes.filter(t => t.projectId == 0);
            var tdyDate = new Date();
            let hour = tdyDate.getHours();
            let min = tdyDate.getMinutes();
            let seconds = tdyDate.getSeconds();

            var date = new Date(selectedDate);
            date.setHours(hour);
            date.setMinutes(min);
            date.setSeconds(seconds);

            if (data.length == 0) {
                let issueNotesList = selectedIssueNotes.filter(t => t.status !== Constants.NEW_STATUS);
                issueNotesList.map(issue => {
                    let attachments = [];
                    issue.attachment.map(attach => {
                        attachments.push({
                            Id: attach.Id,
                            AttachmentType: attach.AttachmentType,
                            AttachmentName: attach.AttachmentName,
                            AttachmentContent: attach.AttachmentContent,
                            IsActive: attach.IsActive
                        });
                    });
                    requestData.push({
                        Id: issue.id,
                        IssueNote: issue.issueNote ? issue.issueNote.toString() : '',
                        ProjectID: issue.projectId,
                        DeviceID: issue.deviceId,
                        CreatedDate: issue.id === 0 ? date : new Date(issue.createdDate),
                        Attachments: attachments,
                        ProjectNumber: issue.projectNumber,
                        Status: issue.status === Constants.ACTIVE ? Constants.IN_PROGRESS : issue.status,
                        IsDeleted: issue.isDeleted,
                        SubmittedByEmployeeId: issue.submittedByEmployeeId ? issue.submittedByEmployeeId : this.props.user.employeeId,
                        SubmittedDeviceName: issue.submittedDeviceName ? issue.submittedDeviceName : this.props.user.deviceEmpID,
                        FieldStatusId: issue.fieldStatusId ? issue.fieldStatusId : null,
                        FieldStatusInitial: issue.fieldStatusInitial,
                        FieldStatusDescription: issue.fieldStatusDescription,
                        LostHours: issue.lostHours ? utility.hoursFormation(issue.lostHours) : "",

                    });
                });
                let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_ISE_NT_M}`;
                Api.Post(url, requestData, this).then((response) => {
                    if (response.success) {
                        MessageBox(response.message, Constants.SUCCESS);
                        this.setState({ isIssueNoteModalVisible: false, selectedIssueNotes: [], isShowIssueNoteSaveConfirmation: false, isSaveIssueNoteButtonDisabled: false }, () => { this.getIssueNotesAndDailyDetailsAndTMVouchersCount(); });
                    } else {
                        MessageBox(response.message, Constants.ERROR);
                    }
                });
            } else {
                MessageBox(Constants.PLEASE_SELECT_PROJECT, Constants.ERROR);
            }
            this.setState({ isSaveIssueNoteButtonDisabled: false, isShowIssueNoteSaveConfirmation: false });
        });
    }

    handleDateChange(date) {
        let { isIssueNoteVisible } = this.state;
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            this.props.groupByInTimecardPage('');
            var date = new Date(date);
            var today = new Date();
            var currentDate = moment(today).format("MM/DD/YYYY");
            var dateSelected = moment(date).format("MM/DD/YYYY");
            isIssueNoteVisible = dateSelected <= currentDate;
            date.setHours(today.getHours());
            date.setMinutes(today.getMinutes());
            this.setState({
                selectedDate: date, isIssueNoteVisible, defaultGroupBy: Constants.EMPLOYEE, timeRecords: []
            }, () => {
                this.props.onSelectDate(this.state.selectedDate);
                this.DeleteUnassignedAndInactiveProjectTimecards();
                this.getStatusCodeList();
            });
        }
        else {
            this.setState({
                timeRecords: []
            });
        }
    }

    onClickEdit = selectedRow => {
        let { timeRecords, selectedDate, payRollNoteListOptions, defaultGroupBy, selectedExpectationsNote } = this.state;
        let selectedNote;

        if (selectedRow.timeCardId) {
            selectedNote = timeRecords[selectedRow.index].timecardData.find(t => t.timeRecordID == selectedRow.timeCardId && t.deviceID == selectedRow.deviceId);
        }
        if (selectedRow.isEditTimeCard) {
            let formatedSelectedDate = moment(selectedDate).format(Constants.MMDDYYYY_SLASH_FORMAT);

            if (defaultGroupBy === Constants.EMPLOYEE) {
                var selectedTimeRecordIds = timeRecords[selectedRow.index].timecardData.map(a => a.timeRecordID);
                this.props.history.push(`edittimecard?sd=${formatedSelectedDate}&tids=${selectedTimeRecordIds}&gb=e`);
            }
            else if (defaultGroupBy === Constants.PROJECT) {
                this.props.groupByInTimecardPage('');
                let selectProjectTimecardRecords = timeRecords[selectedRow.index].timecardData.filter(a => a.projectID === selectedRow.projectID && a.taskCodeID === selectedRow.taskId && a.employeeID === selectedRow.employeeID && a.shift === selectedRow.shift);
                let selectedTimeRecordIds = selectProjectTimecardRecords.map(a => a.timeRecordID);
                this.props.history.push(`edittimecard?sd=${formatedSelectedDate}&tids=${selectedTimeRecordIds}&gb=p`);
            }
        }
        else if (selectedRow.modalOpenPayRollNote) {
            let url = `${ApiUrls.Routes.PAYRL_NTE_C}${ApiUrls.Routes.GT_PAYRL_NTE_LST_M}`;
            Api.Get(url, this).then(response => {
                if (response.success) {
                    var payRollLists = response.data.sort((a, b) => {
                        var nameA = a.name.toUpperCase();
                        var nameB = b.name.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        //name must be equal
                        return 0;
                    });

                    payRollNoteListOptions = [
                        { key: '', value: 'Select', text: '-Select-' },
                        ...(payRollLists?.map(t => ({ key: t.id, value: t.name, text: t.name })) || [])
                    ];

                    this.setState({
                        payRollNoteListOptions
                    }, () => {
                        const selectedPayRollNote = {
                            timeRecordID: selectedRow.timeCardId,
                            deviceID: selectedRow.deviceId,
                            employeeName: selectedRow.employeeName,
                            payRollNotesDropDownValue: 'Select',
                            payRollNoteOtherText: ''
                        };

                        if (selectedNote && selectedNote.payrollNote) {
                            const payRollNotesDropDownValue = this.state.payRollNoteListOptions.find(t => t.text === selectedNote.payrollNote)?.text ?? 'Other';
                            const payRollNoteOtherText = payRollNotesDropDownValue === 'Other' ? selectedNote.payrollNote : '';

                            selectedPayRollNote.payRollNotesDropDownValue = payRollNotesDropDownValue;
                            selectedPayRollNote.payRollNoteOtherText = payRollNoteOtherText;
                        }

                        this.setState({
                            isOpenPayRollNotes: selectedRow.modalOpenPayRollNote,
                            selectedPayRollNote,
                            savedPayRollNote: { ...selectedPayRollNote }
                        });
                    });
                }
            });
        }
        else if (selectedRow.modalOpenExceptationalNote) {
            selectedExpectationsNote = {
                timeRecordID: selectedRow.timeCardId,
                deviceID: selectedRow.deviceId,
                expectationUnits: selectedNote && selectedNote.expectationUnits ? selectedNote.expectationUnits : '',
                expectationNote: selectedNote && selectedNote.expectationNote ? selectedNote.expectationNote : ''
            }
            this.setState({
                isOpenExceptationalNotes: selectedRow.modalOpenExceptationalNote, selectedExpectationsNote, savedExpectationsNote: { ...selectedExpectationsNote }
            });
        }
        else if (selectedRow.modalOpenActualNote) {
            let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATCHMT_BY_TMC_ID_M}?timeRecordId=${selectedRow.timeCardId}&&deviceId=${selectedRow.deviceId}`;
            Api.Get(url, this, true, true).then(response => {
                if (response.success) {
                    let attachmentLists = [];
                    if (response.data.length > 0) {
                        response.data.sort((a, b) => a.id - b.id);
                        response.data.map((attach) => {
                            attachmentLists.push({
                                Id: attach.id,
                                AttachmentType: attach.attachmentType,
                                AttachmentName: attach.attachmentName,
                                AttachmentContent: attach.attachmentContent,
                                IsActive: attach.isActive
                            });
                        });
                    }
                    const selectedActualNote = {
                        timeRecordID: selectedRow.timeCardId,
                        deviceID: selectedRow.deviceId,
                        actualUnits: selectedNote && selectedNote.workUnits ? selectedNote.workUnits : '',
                        actualNote: selectedNote && selectedNote.workNote ? selectedNote.workNote : '',
                        attachments: attachmentLists
                    }
                    this.setState({
                        isOpenActualNotes: selectedRow.modalOpenActualNote, selectedActualNote, savedActualNote: _.cloneDeep(selectedActualNote), isShowLoader: false  // To create deep copy, we may need to use lodash library
                    });
                }
                else {
                    this.setState({ isOpenActualNotes: false, selectedActualNote: {}, isShowLoader: false });
                }
            });

        }

    }

    savePayRollNote(notes) {
        let { selectedPayRollNote, timeRecords, defaultGroupBy } = this.state;

        if (!selectedPayRollNote.payRollNotesDropDownValue) {
            MessageBox(Constants.PLEASE_ENTER_PAYROLL_NOTES, Constants.ERROR);
            this.setState({ isShowPayRollNoteSaveConfimation: false });
            return;
        }

        if (selectedPayRollNote.payRollNotesDropDownValue === 'Other' && !selectedPayRollNote.payRollNoteOtherText.trim()) {
            MessageBox(Constants.PAYROLL_NOTES_MANDATORY, Constants.ERROR);
            return;
        }

        var payroll = selectedPayRollNote.payRollNotesDropDownValue != 'Other' ? selectedPayRollNote.payRollNotesDropDownValue == 'Select' ? '' : selectedPayRollNote.payRollNotesDropDownValue : selectedPayRollNote.payRollNoteOtherText;
        let timeRecordIDs = [];

        if (defaultGroupBy == Constants.EMPLOYEE) {
            var selectedRow = timeRecords.filter(t => t.employeeName === notes.employeeName)[0];
            selectedRow.timecardData.map((t) => {
                timeRecordIDs.push(t.timeRecordID)
            })

        } else {
            timeRecordIDs.push(notes.timeCardId)
        }

        let requestData = {
            TimeRecordIDs: timeRecordIDs,
            DeviceID: notes.deviceId,
            PayrollNote: payroll
        }
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_PARL_NTE_M}`;
        Api.Post(url, requestData, this).then((response) => {
            if (response.success) {
                this.setState({ isOpenPayRollNotes: false, selectedPayRollNote: {}, isShowPayRollNoteSaveConfimation: false }, () => {
                    this.getTimeCardData(this.state.selectedDate, true);
                });
            }
        });
    }

    onChangeWorkDoneAtJobSite = (e, { value, rowIndex, cellIndex }) => {
        let { timeRecords } = this.state;

        let requestData = {
            TimeRecordID: timeRecords[rowIndex].timecardData[cellIndex].timeRecordID,
            DeviceID: timeRecords[rowIndex].timecardData[cellIndex].deviceID,
            WorkDoneAtJobSite: value.checked ? 'Yes' : 'No'
        }
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_JB_WRK_DON_M}`;
        Api.Post(url, requestData, this).then((response) => {
            if (response.success) {
                timeRecords[rowIndex].timecardData[cellIndex].workDoneAtJobSite = value.checked ? 'Yes' : 'No';
                this.setState({ timeRecords });
            }
        });
    }

    saveExpectationNote = notes => {
        let { selectedExpectationsNote } = this.state;
        let requestData = {
            TimeRecordID: notes.timeCardId,
            DeviceID: notes.deviceId,
            ExpectationNote: selectedExpectationsNote.expectationNote,
            ExpectationUnits: Number(selectedExpectationsNote.expectationUnits)
        }
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_EXP_NTE_M}`;
        Api.Post(url, requestData, this).then((response) => {
            if (response.success) {
                this.setState({ isOpenExceptationalNotes: false, selectedExpectationsNote: {}, isShowExpectationNoteSaveConfimation: false });
                this.getTimeCardData(this.state.selectedDate, true);
            }
        });
    }
    onChangeStatusCode = (event, timeRecordId, rowIndex) => {
        let { timeRecords, statusCodeList } = this.state;
        var editedTimecard = timeRecords[rowIndex].timecardData.find(t => t.timeRecordID === timeRecordId);
        let statusCodeListOption = statusCodeList.find(a => a.id === event);
        if (statusCodeListOption !== null && statusCodeListOption.id > 0 && statusCodeListOption.displayText !== '-Select-' && statusCodeListOption.statusInitial !== "") {
            editedTimecard.fieldStatusId = statusCodeListOption.id;
            editedTimecard.fieldStatusDescription = statusCodeListOption.displayText;
            editedTimecard.fieldStatusInitial = statusCodeListOption.statusInitial;
        }
        else {
            editedTimecard.fieldStatusId = null;
            editedTimecard.fieldStatusDescription = null;
            editedTimecard.fieldStatusInitial = null;
        }
        let requestData = {
            TimeRecordID: timeRecordId,
            DeviceID: this.props.device.deviceId,
            FieldStatusId: editedTimecard.fieldStatusId,
            FieldStatusDescription: editedTimecard.fieldStatusDescription,
            FieldStatusInitial: editedTimecard.fieldStatusInitial
        }

        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_A_FSCDLT_M}`;
        Api.Post(url, requestData, this);
        this.setState({ timeRecords });

    }

    saveActualNote = notes => {
        let { selectedActualNote } = this.state;
        let attachmentsList = [];

        selectedActualNote && selectedActualNote.attachments.map((attach) => {
            attachmentsList.push({
                Id: attach.Id,
                AttachmentType: attach.AttachmentType ? attach.AttachmentType : "",
                AttachmentName: attach.AttachmentName ? attach.AttachmentName : '',
                AttachmentContent: attach.AttachmentContent ? attach.AttachmentContent : "",
                IsActive: attach.IsActive
            })
        });

        let requestData = {
            TimeRecordID: notes.timeCardId,
            DeviceID: notes.deviceId,
            WorkUnits: selectedActualNote.actualUnits,
            WorkNote: selectedActualNote.actualNote,
            Attachments: attachmentsList
        }

        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_ACT_NTE_M}`;
        Api.Post(url, requestData, this).then((response) => {
            if (response.success) {
                this.setState({ isOpenActualNotes: false, selectedActualNote: {}, isShowActualNoteSaveConfirmation: false });
                this.getTimeCardData(this.state.selectedDate, true);
            }
        });
    }

    handlePayRollNoteChange = (e, { name, value }) => {
        let { selectedPayRollNote } = this.state;
        selectedPayRollNote.payRollNotesDropDownValue = value;
        selectedPayRollNote.payRollNoteOtherText = '';
        this.setState({ selectedPayRollNote });
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachment: ""
        });
    }

    onClickTimeCardReview() {
        this.setState({
            isOpenTimeCardReview: true
        });
    }

    onCloseTimeCardReview() {
        this.setState({
            isOpenTimeCardReview: false
        })
    }

    onClickGrpByModel() {
        this.setState({
            isGroupByModelVisible: true
        });
    }

    onCloseGrpByModel() {
        this.setState({
            isGroupByModelVisible: false
        });
    }

    onClosePayRollModel = () => {
        this.setState({
            isOpenPayRollNotes: false, selectedPayRollNote: {}, isShowPayRollNoteSaveConfimation: false
        });
    }

    onCloseExpectationNoteModel = () => {
        this.setState({
            isOpenExceptationalNotes: false, selectedExpectationsNote: {}, isShowExpectationNoteSaveConfimation: false
        });
    }

    onCloseActualNoteModel = () => {
        this.setState({
            isOpenActualNotes: false, selectedActualNote: {}, isShowActualNoteSaveConfirmation: false
        });
    }

    onChangeGroupByOption = (groupBy) => {
        let { defaultGroupBy, isShowTimeCardError, timeRecords } = this.state;
        switch (groupBy) {
            case Constants.PROJECT:
                defaultGroupBy = groupBy;
                break;
            case Constants.EMPLOYEE:
                defaultGroupBy = groupBy;
                break;
        }
        const hasShowErrorTimecard = timeRecords.some(val =>
            val.timecardData.some(record => record.showTimeCardError === true)
        );
        if (!hasShowErrorTimecard) {
            isShowTimeCardError = false;
        }
        this.props.groupByInTimecardPage(defaultGroupBy);
        this.setState({ defaultGroupBy: groupBy, isGroupByModelVisible: false, isShowTimeCardError }, () => {
            this.getTimeCardData(this.state.selectedDate, true);
        });
    }

    onClickDeleteIcon = (value) => {
        if (value.isAttested) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.TIMECARD_ALREADY_ATTESTED_MESSAGE });
        } else {
            let { timeRecords, defaultGroupBy, selectedTimeRecordsForDelete } = this.state;
            timeRecords[value.rowIndex].timecardData[value.cellIndex].isDelete = true;
            selectedTimeRecordsForDelete = [{
                TimerecordId: timeRecords[value.rowIndex].timecardData[value.cellIndex].timeRecordID,
                DeviceId: timeRecords[value.rowIndex].timecardData[value.cellIndex].deviceID,
                IsDelete: timeRecords[value.rowIndex].timecardData[value.cellIndex].isDelete,
                TimerecordHourId: timeRecords[value.rowIndex].timecardData[value.cellIndex].timeRecordHourId
            }];
            this.setState({
                timeRecords, selectedTimeRecordsForDelete, isDeleteConfirmationPopupVisible: true, isDeleteIconClicked: true
            });
        }
    }

    onSelectedTimeCard(e, { value, rowIndex, cellIndex, isAttested }) {
        if (isAttested) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.TIMECARD_ALREADY_ATTESTED_MESSAGE });
        } else {
            let { timeRecords, selectedTimeRecordsForDelete } = this.state;
            if (value.checked) {
                timeRecords[rowIndex].timecardData[cellIndex].isDelete = true;
                timeRecords[rowIndex].timecardData[cellIndex].checked = true;
                selectedTimeRecordsForDelete.push({
                    TimerecordId: timeRecords[rowIndex].timecardData[cellIndex].timeRecordID,
                    DeviceId: timeRecords[rowIndex].timecardData[cellIndex].deviceID,
                    IsDelete: timeRecords[rowIndex].timecardData[cellIndex].isDelete,
                    TimerecordHourId: timeRecords[rowIndex].timecardData[cellIndex].timeRecordHourId
                });
            }
            else {
                timeRecords[rowIndex].timecardData[cellIndex].isDelete = false;
                timeRecords[rowIndex].timecardData[cellIndex].checked = false;
                var timecardId = timeRecords[rowIndex].timecardData[cellIndex].timeRecordID;
                var timecardHoursId = timeRecords[rowIndex].timecardData[cellIndex].timeRecordHourId;
                selectedTimeRecordsForDelete.splice(selectedTimeRecordsForDelete.findIndex(a => a.TimerecordId === timecardId && a.TimerecordHourId === timecardHoursId), 1);
            }
            this.setState({
                timeRecords, selectedTimeRecordsForDelete
            });
        }
    }

    deleteTimeCard = () => {
        let { selectedTimeRecordsForDelete } = this.state;
        let timeRecords = [];
        selectedTimeRecordsForDelete && selectedTimeRecordsForDelete.map((timerecord) => {
            timeRecords.push({
                TimeRecordId: timerecord.TimerecordId,
                DeviceId: timerecord.DeviceId,
                IsDelete: timerecord.IsDelete,
                TimeRecordHourId: timerecord.TimerecordHourId
            })
        });
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.DL_TMC_M}`;
        Api.Post(url, timeRecords, this).then((response) => {
            if (response.success) {
                MessageBox(response.message, Constants.SUCCESS);
                this.setState({ isDeleteConfirmationPopupVisible: false, selectedTimeRecordsForDelete: [], isDeleteIconClicked: false });
                this.onCancelCheckBox();
                this.getTimeCardData(this.state.selectedDate, true);
            }
        });
    }

    onClickSubmit() {
        let { timeRecords, selectedDate, taskCodeIdAndProjectIdWithTMCode } = this.state;
        const isShowTMVoucherTag = taskCodeIdAndProjectIdWithTMCode.length > 0;
        var datePicked = new Date(selectedDate);
        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = new Date(datePicked);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        var dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);

        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ISE_NT_CNT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}&status=${Constants.IN_PROGRESS}`;
        Api.Get(url, this).then(responseData => {
            if (responseData.success) {
                let inProgressIssueNoteCount = responseData.totalCount;
                if (timeRecords && timeRecords.length == 0 && inProgressIssueNoteCount == 0) {
                    MessageBox(Constants.PLEASE_SELECT_SOME_TIMECARDS, Constants.ERROR);
                    return;
                } else if (timeRecords && timeRecords.length == 0 && inProgressIssueNoteCount > 0) {
                    url = `${ApiUrls.Routes.DALY_DET_C}${ApiUrls.Routes.GT_DALY_DET_CNT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}&status=${Constants.IN_PROGRESS}`;
                    Api.Get(url, this).then(responseData => {
                        if (responseData.success) {
                            let dailyDetailsCount = responseData.totalCount;
                            if (dailyDetailsCount > 0) {
                                MessageBox(Constants.PLEASE_SELECT_SOME_TIMECARDS, Constants.ERROR);
                                return;
                            } else {
                                const confirmationIssueNotePopupMessage = <p>Do you want to submit the issue note(s){isShowTMVoucherTag ? ` and T&M tag(s)` : ""}? <br /><br /> Once submitted the issue notes can only be modified by your manager in Time entry.</p>;
                                this.setState({
                                    isSubmitConfirmationModelVisible: true,
                                    isSubmitConfirmationMessage: confirmationIssueNotePopupMessage
                                });
                            }
                        } else {
                            MessageBox(responseData.message, Constants.ERROR);
                        }
                    });
                } else if (timeRecords && timeRecords.length > 0) {
                    const confirmationTimecardPopupMessage = <p>Do you want to submit the timecard(s){isShowTMVoucherTag ? ` and T&M tag(s)` : ""}? <br /><br />Once submitted the timecards can only be modified by your manager in Time entry.</p>;
                    this.setState({
                        isSubmitConfirmationModelVisible: true,
                        isSubmitConfirmationMessage: confirmationTimecardPopupMessage
                    });
                }
            } else {
                MessageBox(responseData.message, Constants.ERROR);
            }
        });
    }
    onSyncButton() {
        window.location.reload();
    }
    onClickSync() {
        this.setState({ isShowLoader: true }, () => {
            let { selectedDate, totalTimeCardList, isHaveDupicateTimeRecord } = this.state;
            let isValidData = true;
            if (totalTimeCardList && totalTimeCardList.length > 0) {
                isHaveDupicateTimeRecord = this.checkTimecardDuplicate(true);
            }
            if (isHaveDupicateTimeRecord) {
                MessageBox(Constants.TIMECARD_IS_DUPLICATE, Constants.ERROR);
                isValidData = false;
                this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false, isHaveDupicateTimeRecord });
            }
            else if (totalTimeCardList && totalTimeCardList.length > 0) {
                for (var timecard of totalTimeCardList) {
                    let stDayShiftHours = 0;
                    let stEveningShiftHours = 0;
                    let stNightShiftHours = 0;

                    totalTimeCardList.filter(t => {
                        if (t.employeeID === timecard.employeeID) {
                            if (t.shift === Constants.DAY) {
                                stDayShiftHours += Number(t.stHours);
                            }
                            else if (t.shift === Constants.EVENING) {
                                stEveningShiftHours += Number(t.stHours);
                            }
                            else if (t.shift === Constants.NIGHT) {
                                stNightShiftHours += Number(t.stHours);
                            }
                        }
                        return t;
                    });

                    if (!timecard.projectID) {
                        MessageBox(Constants.SELECT_VALID_PROJECT, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                    else if (!timecard.taskCodeID) {
                        MessageBox(Constants.SELECT_VALID_TASK_CODE, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                    else if (!timecard.shift) {
                        MessageBox(Constants.SELECT_VALID_SHIFT, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                    else if (timecard.workDoneAtJobSite === null || timecard.workDoneAtJobSite === '') {
                        MessageBox(Constants.PLEASE_CHOOSE_WORK_DONE, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                    else if (Number(timecard.stHours) == 0 && Number(timecard.otHours) == 0 && Number(timecard.dtHours) == 0 && !timecard.payrollNote) {
                        MessageBox(Constants.PLEASE_ENTER_PAYROLL_FOR_EMPLOYEE_WITH_ZERO_HOURS, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                    else if ((stDayShiftHours > 10) || (stEveningShiftHours > 10) || (stNightShiftHours > 10)) {
                        MessageBox(Constants.ST_HOURS_CANNOT_BE_GREATER, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }

                    const allPunches = [timecard.startTime, timecard.endTime, timecard.lunchStartTime, timecard.lunchEndTime]
                    const startTimeAndEndTime = allPunches.slice(0, 2);
                    const totalHours = Number(timecard.stHours) + Number(timecard.otHours) + Number(timecard.dtHours);
                    const isGreaterThanFourHours = CheckEnterHours(totalHours);
                    const isGreaterThanZero = totalHours > 0;
                    if (isGreaterThanZero && (startTimeAndEndTime.some(a => a === "") || startTimeAndEndTime.some(a => a === Constants.NOT_APPLICABLE))) {
                        MessageBox(Constants.ENTER_START_TIME_AND_END_TIME, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                    if (isGreaterThanFourHours && (allPunches.some(a => a === "") || allPunches.some(a => a === Constants.NOT_APPLICABLE))) {
                        MessageBox(Constants.REQUIRE_ALL_PUNCHES, Constants.ERROR);
                        isValidData = false;
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false, isSubmitConfirmationModelVisible: false });
                        break;
                    }
                }
            }
            if (isValidData) {
                var datePicked = new Date(selectedDate);
                var startTime = new Date(datePicked.setHours(0, 0, 0));
                var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
                var tomorrow = new Date(datePicked);
                var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
                var endDate = new Date(endTime);
                endDate.setHours(0, 0, 0);
                var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
                var selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
                var dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
                var timeZone = startDate.toString();
                var selectTimeZone = timeZone.slice(16, 24);
                let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SBT_TMRD_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}&employeeId=${this.props.user.employeeId}`;
                Api.Post(url, this.state.taskCodeIdAndProjectIdWithTMCode, this).then((response) => {
                    if (response.success) {
                        if (response.isValidToContinue) {
                            let { submittedTimeRecordCount, submittedIssueNoteCount, tmTaskCodeList } = this.state;
                            submittedTimeRecordCount = response.submittedTimeRecordsCount;
                            submittedIssueNoteCount = response.submittedIssueNotesCount;
                            const submittedTMVoucherCount = response.submittedTMVouchersCount;
                            let isTimeCardHasTMCode = response.submittedTMVouchersCount > 0 ? true : tmTaskCodeList.length > 0 ? true : false;
                            if (submittedTimeRecordCount == 0 && submittedIssueNoteCount > 0) {
                                const issueNoteSubmittedMessage = `${submittedIssueNoteCount} Issue note${submittedIssueNoteCount > 1 ? 's' : ''} ${submittedTMVoucherCount > 0 ? `and ${submittedTMVoucherCount} T&M tag${submittedTMVoucherCount > 1 ? 's' : ''} ` : ""}have been submitted`;
                                this.setState({
                                    isSubmitIssueNoteModelVisible: true,
                                    isSubmitConfirmationModelVisible: false,
                                    submittedTimeRecordCount,
                                    submittedIssueNoteCount,
                                    isTimeCardHasTMCode,
                                    issueNoteSubmittedMessage
                                });
                            } else if (submittedTimeRecordCount > 0) {
                                MessageBox(Constants.SUBMIT_SUCCESSFULLY, Constants.SUCCESS);
                                const timeCardSubmittedMessage = `${submittedTimeRecordCount} Timecard${submittedTimeRecordCount > 1 ? 's' : ''} ${submittedTMVoucherCount > 0 ? `and ${submittedTMVoucherCount} T&M tag${submittedTMVoucherCount > 1 ? 's' : ''} ` : ""}have been submitted`;
                                this.setState({
                                    isSubmitModelVisible: true,
                                    isSubmitConfirmationModelVisible: false,
                                    submittedTimeRecordCount,
                                    submittedIssueNoteCount,
                                    isTimeCardHasTMCode,
                                    timeCardSubmittedMessage,
                                    isTMVoucherSubmitted: response.submittedTMVouchersCount > 0
                                });
                            } else {
                                MessageBox(Constants.PLEASE_SELECT_SOME_TIMECARDS, Constants.ERROR);
                                this.setState({
                                    isSubmitConfirmationModelVisible: false
                                }, () => {
                                    this.getTimeCardData();
                                });
                            }
                        } else {
                            this.onClickLogout();
                        }
                    } else {
                        this.setState({
                            isSubmitConfirmationModelVisible: false
                        });
                        MessageBox(response.message, Constants.ERROR);
                    }
                });
            }
        });
    }


    checkTimecardDuplicate = (onSync = false) => {
        let { totalTimeCardList } = this.state;
        var isHaveDupicateTimeRecord = false;
        for (var timecard of totalTimeCardList) {
            let duplicateRecords = totalTimeCardList.filter(c => c.employeeID === timecard.employeeID && c.projectID === timecard.projectID && c.taskCodeID === timecard.taskCodeID && c.shift === timecard.shift && !c.isDeleted);
            if (duplicateRecords && duplicateRecords.length > 1) {
                isHaveDupicateTimeRecord = true;
                var isFirstRecord = true;
                for (var dt of duplicateRecords) {
                    if (!isFirstRecord) {
                        dt.isDuplicate = true;
                    }
                    isFirstRecord = false;
                }
            }
        }
        this.setState({ totalTimeCardList });
        if (onSync) {
            return isHaveDupicateTimeRecord;
        }
    }

    onCancelDeletePopup = () => {
        if (this.state.isDeleteIconClicked) {
            this.onCancelCheckBox();
        }
        else {
            this.setState({ isDeleteConfirmationPopupVisible: false });
        }
    }

    onCancelCheckBox = () => {
        let { timeRecords } = this.state;
        timeRecords && timeRecords.map((timerecord) => {
            timerecord.timecardData.map((tcData) => {
                tcData.checked = false;
            });
        });
        this.setState({ isDeleteConfirmationPopupVisible: false, isDeleteIconClicked: false, selectedTimeRecordsForDelete: [], timeRecords });
    }

    onClickDeleteButton = () => {
        let { selectedTimeRecordsForDelete } = this.state;
        if (selectedTimeRecordsForDelete.length === 0) {
            MessageBox(Constants.PLEASE_SELECT_SOME_RECORDS_TO_DELETE, Constants.ERROR);
        } else {
            this.setState({ isDeleteConfirmationPopupVisible: true });
        }
    }

    handlePayRollNoteTextChange(event) {
        let { selectedPayRollNote } = this.state;
        selectedPayRollNote.payRollNoteOtherText = event.target.value;
        this.setState({
            selectedPayRollNote
        });
    }

    handleExpectationUnitChange(event) {
        let { selectedExpectationsNote } = this.state;
        selectedExpectationsNote.expectationUnits = event.target.value ? Number(utility.allowOnlyPositiveNumeric(event.target.value)) : '';
        this.setState({
            selectedExpectationsNote
        });
    }

    handleExpectationNoteChange(event) {
        let { selectedExpectationsNote } = this.state;
        if (event.target.value.length <= 1000) {
            selectedExpectationsNote.expectationNote = event.target.value;
        }
        else {
            MessageBox(Constants.MAXLENGTH_REACHED, Constants.ERROR);
            return;
        }
        this.setState({
            selectedExpectationsNote
        });
    }

    handleActualUnitChange(event) {
        let { selectedActualNote } = this.state;
        selectedActualNote.actualUnits = utility.allowOnlyPositiveNumeric(event.target.value);
        this.setState({
            selectedActualNote
        });
    }

    handleActualNoteChange(event) {
        let { selectedActualNote } = this.state;

        if (event.target.value.length <= 1000) {
            selectedActualNote.actualNote = event.target.value;
        }
        else {
            MessageBox(Constants.MAXLENGTH_REACHED, Constants.ERROR);
            return;
        }
        this.setState({
            selectedActualNote
        });
    }

    onClickAddTimeCard = () => {
        this.props.history.push("/AddTimeCard", { isAddTimeCard: true });
    }

    onClickHelp = () => {
        window.open(configSettings.serviceNowUrl,"_blank");
    }

    getEmployeeSortedTimeCardList() {
        const { timeRecords } = this.state;
        let loadAllDataWithoutGroup = [];
        timeRecords.map(a => {
            loadAllDataWithoutGroup = loadAllDataWithoutGroup.concat(a.timecardData);
        });
        loadAllDataWithoutGroup.sort((a, b) => a.timeRecordID - b.timeRecordID);
        const groupByEmployeeList = loadAllDataWithoutGroup.reduce((prev, curr) => {
            var previousData = prev.find(a => a.employeeID == curr.employeeID);
            if (prev && previousData) {
                previousData.timecardData = [...previousData.timecardData || [], curr];
                previousData.totalStHours = Number(previousData.totalStHours) + Number(curr.stHours ? curr.stHours : 0);
                previousData.totalOtHours = Number(previousData.totalOtHours) + Number(curr.otHours ? curr.otHours : 0);
                previousData.totalDtHours = Number(previousData.totalDtHours) + Number(curr.dtHours ? curr.dtHours : 0);
            }
            else {
                prev.push({
                    employeeName: curr.fullName,
                    employeeID: curr.employeeID,
                    timecardData: [curr],
                    totalStHours: Number(curr.stHours ? curr.stHours : 0),
                    totalOtHours: Number(curr.otHours ? curr.otHours : 0),
                    totalDtHours: Number(curr.dtHours ? curr.dtHours : 0)
                });
            }
            return prev;
        }, []);
        return groupByEmployeeList;
    }

    onClickStartAndLunchTime = (data, isTimeCardAttested) => {
        if (isTimeCardAttested) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.TIMECARD_ALREADY_ATTESTED_PUNCHES_MESSAGE });
            return;
        }
        let selectedRowData = data;
        if (this.state.defaultGroupBy === Constants.PROJECT) {
            const groupByEmployeeList = this.getEmployeeSortedTimeCardList().find(a => a.employeeID === data.employeeID);
            selectedRowData = groupByEmployeeList.timecardData;
        }
        this.props.groupByInTimecardPage('');
        this.props.history.push("/AddTimeCard", { isFromTimeCard: true, timeCardDatas: data, groupBy: this.state.defaultGroupBy, selectedRowData });
    }

    onClickLogout = () => {
        utility.removeActiveEventListener();
        this.props.logout();
        //this.props.deviceRegistrationSuccess(false,"",null);
        this.props.login(false, "", "", null, "", "", null);
        this.props.onSelectDate(null);
        this.props.history.push("/Login");
    }

    onClickPayRollNoteBack() {
        const { selectedPayRollNote, savedPayRollNote } = this.state;

        if (!_.isEqual(selectedPayRollNote, savedPayRollNote)) {
            this.setState({
                isShowPayRollNoteSaveConfimation: true
            })
        } else {
            this.onClosePayRollModel();
        }
    }

    onClickIssueNotesBack() {
        const { selectedIssueNotes, savedIssueNotes } = this.state;

        if (!_.isEqual(selectedIssueNotes, savedIssueNotes)) {
            this.setState({
                isShowIssueNoteSaveConfirmation: true
            });
        } else {
            this.closeIssueNotes();
        }
    }

    onClickExpectationNoteBack() {
        const { selectedExpectationsNote, savedExpectationsNote } = this.state;

        if (!_.isEqual(selectedExpectationsNote, savedExpectationsNote)) {
            this.setState({
                isShowExpectationNoteSaveConfimation: true
            });
        } else {
            this.onCloseExpectationNoteModel();
        }
    }

    onClickActualNoteBack() {
        const { selectedActualNote, savedActualNote } = this.state;

        if (!_.isEqual(selectedActualNote, savedActualNote)) {
            this.setState({
                isShowActualNoteSaveConfirmation: true
            });
        } else {
            this.onCloseActualNoteModel();
        }
    }

    closeSubmitConfirmationModal() {
        this.setState({
            isSubmitConfirmationModelVisible: false
        })
    }

    onChangeActulNoteAttachment = (images) => {
        this.setState({ isActualNoteSaveBtnDisabled: true }, () => {
            const { selectedActualNote } = this.state;
            const attachments = selectedActualNote?.attachments ?? [];
            utility.maximumImageCheck(attachments, images).then((data) => {
                if (data.success) {
                    selectedActualNote.attachments = attachments;
                    this.setState({ selectedActualNote, isActualNoteSaveBtnDisabled: false });
                }
                else {
                    this.setState({ isActualNoteSaveBtnDisabled: false });
                }
            })
        });
    }

    onActualNoteAttachmentRemove = (index) => {
        let { selectedActualNote } = this.state;
        if (selectedActualNote.attachments[index].Id) {
            selectedActualNote.attachments[index].IsActive = false
        } else {
            selectedActualNote.attachments.splice(index, 1);
        }
        this.setState({
            selectedActualNote
        });
    }
    onClickDailyDetails = () => {
        let { selectDate, dateSelected, selectedDate } = this.state;
        this.props.history.push("/DailyDetails", { fromDate: selectDate, toDate: dateSelected, isAllowToEdit: true, selectedDate: selectedDate.toJSON() });
    }


    onClickCurrentWeekTimeCard() {
        this.props.history.push("/CurrentWeekTimeCard");
    }

    onClickPreviousWeekTimeCard() {
        this.props.history.push("/PreviousWeekTimeCard");
    }

    onClickSubmittedTimeCardPage() {
        this.props.history.push("/SubmittedTimeCard");

    }

    closeSubmitModel() {
        let { selectedDate, isTimeCardHasTMCode } = this.state;
        var currentDate = moment(new Date()).format("MM/DD/YYYY");
        var pickedDate = moment(selectedDate).format("MM/DD/YYYY");
        var isSelectPastDate = pickedDate != currentDate ? true : false;
        var current = new Date();
        var monday = (new Date(current.setDate(current.getDate() - current.getDay() + (current.getDay() == 0 ? -6 : 1))));
        var sunday = (new Date(current.setDate(current.getDate() - current.getDay() + 7)));
        if (isSelectPastDate && !isTimeCardHasTMCode) {
            this.setState({
                selectedDate: new Date(), weekEndingDate: sunday, weekStartDate: monday, isSubmitModelVisible: false, defaultGroupBy: Constants.EMPLOYEE, isShowTMVoucher: isTimeCardHasTMCode
            }, () => { this.props.onSelectDate(this.state.selectedDate); this.getTimeCardData(); this.getIssueNotesAndDailyDetailsAndTMVouchersCount(); this.getStatusCodeList(); this.getTMVoucherTaskCodes(); });
        } else {
            this.setState({
                isSubmitModelVisible: false,
                isShowTMVoucher: isTimeCardHasTMCode
            }, () => { this.getTimeCardData(); this.getIssueNotesAndDailyDetailsAndTMVouchersCount(); this.getStatusCodeList(); this.getTMVoucherTaskCodes(); });
        }
    }

    closeIssueNotesSubmitModel() {
        let { selectedDate, isTimeCardHasTMCode } = this.state;
        var currentDate = moment(new Date()).format("MM/DD/YYYY");
        var pickedDate = moment(selectedDate).format("MM/DD/YYYY");
        var isSelectPastDate = pickedDate != currentDate ? true : false;
        var current = new Date();
        var monday = (new Date(current.setDate(current.getDate() - current.getDay() + (current.getDay() == 0 ? -6 : 1))));
        var sunday = (new Date(current.setDate(current.getDate() - current.getDay() + 7)));
        if (isSelectPastDate && !isTimeCardHasTMCode) {
            this.setState({
                selectedDate: new Date(), weekEndingDate: sunday, weekStartDate: monday, isSubmitIssueNoteModelVisible: false, isShowTMVoucher: isTimeCardHasTMCode
            }, () => { this.props.onSelectDate(this.state.selectedDate); this.getTimeCardData(); this.getIssueNotesAndDailyDetailsAndTMVouchersCount(); this.getTMVoucherTaskCodes(); });
        } else {
            this.setState({
                isSubmitIssueNoteModelVisible: false,
                isShowTMVoucher: isTimeCardHasTMCode
            }, () => {
                this.getIssueNotesAndDailyDetailsAndTMVouchersCount();
                this.getTMVoucherTaskCodes();
            });
        }
    }

    handleDatePickerOpenAndClose(isDateOpen = false) {
        if (typeof isDateOpen === 'boolean' && isDateOpen) {
            this.setState({ isDatePickerOpen: false });
        } else {
            this.setState({ isDatePickerOpen: true });
        }
    }

    onClickTMVoucherBtn() {
        this.setState({ isShowTMVoucher: true });
    }

    onClickTMVoucherBackBtn() {
        const { selectedTMVoucher } = this.state;
        isEqual(selectedTMVoucher, {}) ? this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} }) : this.setState({ isShowTMVoucher: false, selectedTMVoucher: {} });
    }

    onChangeSelectTaskCode(tmVoucher) {
        this.setState({ selectedTMVoucher: tmVoucher });
    }

    onClickSelectBtn() {
        const { selectedTMVoucher } = this.state;
        if (isEqual(selectedTMVoucher, {})) {
            MessageBox(Constants.PLEASE_SELECT_TASK_CODE, Constants.ERROR);
        } else {
            const url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.IS_TM_VCHR_PRJ_UN_ASD_M}?deviceId=${this.props.device.deviceId}&projectId=${selectedTMVoucher.projectId}&taskCodeId=${selectedTMVoucher.taskCodeID}&projectNumber=${selectedTMVoucher.projectNumber}&tmVoucherId=${selectedTMVoucher.id}`;
            Api.Get(url, this).then((response) => {
                if (response.success && response.data) {
                    const isProjectUnAssigned = response.data.isProjectUnAssigned || !response.data.isTMCodeInTaskCode;
                    const goToReportPage = isProjectUnAssigned;
                    this.props.selectedTMVoucherData(selectedTMVoucher);
                    this.props.history.push("/TMVoucherDataEntry", { isProjectUnAssigned, goToReportPage });
                } else {
                    MessageBox(response.message, Constants.ERROR);
                }
            });
        }
    }

    getTMVoucherTaskCodes() {
        const { selectedDate } = this.state;
        let datePicked = new Date(selectedDate);
        let startTime = new Date(datePicked.setHours(0, 0, 0));
        let startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        let tomorrow = new Date(datePicked);
        let endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        let endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        let dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        let selectDate = moment(startDate).format(Constants.DDMMYYYY_FORMAT);
        let dateSelected = moment(dateEndTime).format(Constants.DDMMYYYY_FORMAT);
        let timeZone = startDate.toString();
        let selectTimeZone = timeZone.slice(16, 24);
        let url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_TM_VCHR_PRJ_TK_LT_M}?fromDate=${selectDate}@${selectTimeZone}&&toDate=${dateSelected}@${selectTimeZone}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then((response) => {
            if (response.success) {
                if (response.data && response.data.length > 0) {
                    this.setState({ tmTaskCodeList: response.data, isTimeCardHasTMCode: true });
                } else {
                    this.setState({ tmTaskCodeList: [], isTimeCardHasTMCode: false });
                }
            } else {
                this.setState({ tmTaskCodeList: [], isTimeCardHasTMCode: false });
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    openOrCloseAttestationModals(modalName) {
        switch (modalName) {
            case Constants.ATTESTATION_ERROR_MODAL:
                this.setState({ isShowAttestationErrorModal: false, attestErrorValidationMessage: "", isShowBackAttestationModal: false, isAttestationSaveBtnDisabled: false });
                break;
            case Constants.ATTESTATION_CLOSE_WARNING_MODAL:
                this.setState({ isRejectedAttestation: false, rejectedAttestationEmployeeList: [] });
                break;
            case Constants.ATTESTATION_SUBMIT_TIMECARD:
                this.setState({ isRejectedAttestation: false, rejectedAttestationEmployeeList: [] }, () => {
                    this.onClickSubmit();
                });
                break;
            default:
                break;
        }
    }

    gatherTimeCardIds() {
        const ST_MAX_HOURS = 10;
        const { totalTimeCardList, validationTimeRecordIdsWithTypes } = this.state;
        let payRollNotesTimeRecordIds = [];
        let notAttestedTimeRecordIds = [];
        const rejectedAttestationEmployeeList = [];
        let duplicateTimeRecordIds = [];
        const uniqueRecords = new Set();

        const groupByEmployee = totalTimeCardList.reduce((prev, curr) => {
            const previous = prev.find(a => a.empId === curr.employeeID);
            const timeRecordHours = Number(curr.stHours) + Number(curr.otHours) + Number(curr.dtHours);
            const punches = [curr.startTime, curr.lunchStartTime, curr.lunchEndTime, curr.endTime];
            const timeRecordId = curr.timeRecordID;
            const shift = curr.shift;
            const stHours = Number(curr.stHours);
            const payRollNote = curr.payrollNote ?? "";
            const attestationStatus = curr.attestationStatus;
            const empName = `${curr.fullName} (${curr.employeeNumber})`;
            const dataKey = `${curr.employeeID} ${curr.projectID} ${curr.taskCodeID} ${curr.shift}`;


            if (timeRecordHours === 0 && !payRollNote) {
                payRollNotesTimeRecordIds.push(timeRecordId);
            }

            if (!attestationStatus) {
                notAttestedTimeRecordIds.push(timeRecordId)
            }

            if (attestationStatus === Constants.ATTESTATION_STATUS_REJECTED && !rejectedAttestationEmployeeList.includes(empName)) {
                rejectedAttestationEmployeeList.push(empName);
            }

            if (uniqueRecords.has(dataKey)) {
                duplicateTimeRecordIds.push(timeRecordId);
            } else {
                uniqueRecords.add(dataKey);
            }

            if (previous) {
                previous.hours.push(timeRecordHours);
                previous.timeRecordIds.push(timeRecordId);
                previous.totalHours += timeRecordHours;
                if (previous.stHours[shift]) {
                    previous.stHours[shift] += stHours;
                } else {
                    previous.stHours[shift] = stHours;
                }
            } else {
                prev.push({
                    empId: curr.employeeID,
                    punches: punches,
                    hours: [timeRecordHours],
                    stHours: { [shift]: stHours },
                    timeRecordIds: [timeRecordId],
                    totalHours: timeRecordHours
                });
            }
            return prev;
        }, []);

        const getTimeCardIds = (arr) => arr.map(a => a.timeRecordIds).flat();
        const totalStHours = (stHours) => Object.values(stHours).reduce((sum, value) => sum + value, 0);

        let timecardsWithHoursAndNA = getTimeCardIds(groupByEmployee.filter(a => a.hours.some(b => b > 0) && a.punches.every(b => b === Constants.NOT_APPLICABLE)));
        let timecardsWithZeroHoursAndNotNA = getTimeCardIds(groupByEmployee.filter(a => a.hours.every(b => b === 0) && a.punches.some(b => b !== Constants.NOT_APPLICABLE)));
        let timecardsWithAboveFourPointFiveHoursAndNA = getTimeCardIds(groupByEmployee.filter(a => (a.hours.some(CheckEnterHours) || CheckEnterHours(a.totalHours)) && a.punches.some(b => b === Constants.NOT_APPLICABLE)));
        const isSTHoursGreaterThanTen = Object.entries(groupByEmployee).filter(([_, value]) => totalStHours(value.stHours) > ST_MAX_HOURS).length > 0;

        if (!timecardsWithHoursAndNA || timecardsWithHoursAndNA?.length === 0) {
            timecardsWithHoursAndNA = getTimeCardIds(groupByEmployee.filter(a => a.punches.some(b => !b)));
        }

        //payroll
        if (payRollNotesTimeRecordIds.length > 0) {
            duplicateTimeRecordIds = [];
            notAttestedTimeRecordIds = [];
            timecardsWithHoursAndNA = [];
            timecardsWithZeroHoursAndNotNA = [];
            timecardsWithAboveFourPointFiveHoursAndNA = [];
        }

        //punches
        if (timecardsWithHoursAndNA.length > 0 || timecardsWithZeroHoursAndNotNA.length > 0 || timecardsWithAboveFourPointFiveHoursAndNA.length > 0 || validationTimeRecordIdsWithTypes.find(a => a.type === Constants.PUNCHES)?.id?.length > 0) {
            duplicateTimeRecordIds = [];
            notAttestedTimeRecordIds = [];
        }

        //duplicate
        if (duplicateTimeRecordIds.length > 0 || validationTimeRecordIdsWithTypes.find(a => a.type === Constants.DUPLICATE)?.id?.length > 0) {
            notAttestedTimeRecordIds = [];
        }

        this.setState({ validationTimeRecordIdsWithTypes: [] })
        return { timecardsWithHoursAndNA, timecardsWithZeroHoursAndNotNA, timecardsWithAboveFourPointFiveHoursAndNA, isSTHoursGreaterThanTen, payRollNotesTimeRecordIds, notAttestedTimeRecordIds, rejectedAttestationEmployeeList, duplicateTimeRecordIds };
    }

    showValidation(timeRecordIdsForCheck, validationMessage, isFromGroupByOptionMethod, includeBreak = true, ignoreBorder = false) {
        const { timeRecords } = this.state;
        let isShowTimeCardError = false;
        if (!ignoreBorder) {
            for (let tb of timeRecords) {

                const timeRecordIds = tb.timecardData.map(a => a.timeRecordID);

                for (let td of tb.timecardData) {
                    td.showTimeCardError = false; // Reset the error flag initially

                    if (this.state.defaultGroupBy === Constants.PROJECT) {
                        if (timeRecordIdsForCheck.includes(td.timeRecordID)) {
                            td.showTimeCardError = true;
                            isShowTimeCardError = true;
                        }
                    } else {
                        if (includeBreak) {
                            if (timeRecordIds.some(id => timeRecordIdsForCheck.includes(id))) {
                                td.showTimeCardError = true;
                                isShowTimeCardError = true;
                                break; // Break as soon as we find a match
                            }
                        } else {
                            if (timeRecordIdsForCheck.includes(td.timeRecordID)) {
                                td.showTimeCardError = true;
                                isShowTimeCardError = true;
                            }
                        }
                    }
                }
            }
        }

        if (!isFromGroupByOptionMethod) {
            MessageBox(validationMessage, Constants.ERROR);
        }
        this.setState({ isShowLoader: false, isShowTimeCardError });
    }

    validateTimeCardSubmit(isFromGroupByOptionMethod = false) {
        const { isAllowAttestation } = this.state;
        const { timecardsWithHoursAndNA, timecardsWithZeroHoursAndNotNA, timecardsWithAboveFourPointFiveHoursAndNA, isSTHoursGreaterThanTen, payRollNotesTimeRecordIds, notAttestedTimeRecordIds, rejectedAttestationEmployeeList, duplicateTimeRecordIds } = this.gatherTimeCardIds();
        const punchesValidation = { type: Constants.PUNCHES, id: [...timecardsWithHoursAndNA, ...timecardsWithZeroHoursAndNotNA, ...timecardsWithAboveFourPointFiveHoursAndNA] };
        const duplicate = { type: Constants.DUPLICATE, id: duplicateTimeRecordIds };
        const notAttest = { type: Constants.NOTATTEST, id: notAttestedTimeRecordIds };

        this.setState({ validationTimeRecordIdsWithTypes: [punchesValidation, duplicate, notAttest] });

        // Payroll validation
        if (payRollNotesTimeRecordIds.length > 0) {
            this.showValidation(payRollNotesTimeRecordIds, Constants.PLEASE_ENTER_PAYROLL_FOR_EMPLOYEE_WITH_ZERO_HOURS, isFromGroupByOptionMethod, false, true);
            return;
        }

        // Punches validation
        if (timecardsWithAboveFourPointFiveHoursAndNA.length > 0) {
            // Timecard punches contains N/A and hours greater than 4.5 hours
            this.showValidation(timecardsWithAboveFourPointFiveHoursAndNA, Constants.REQUIRE_ALL_PUNCHES, isFromGroupByOptionMethod, false);
            return;
        } else if (timecardsWithHoursAndNA.length > 0) {
            // Timecard all punches contains N/A and hours greater than 0 hours
            this.showValidation(timecardsWithHoursAndNA, Constants.REQUIRE_ALL_PUNCHES, isFromGroupByOptionMethod);
            return;
        } else if (timecardsWithZeroHoursAndNotNA.length > 0) {
            // Zero timecard punches does not contains N/A
            this.showValidation(timecardsWithZeroHoursAndNotNA, Constants.PLEASE_ENTER_NA, isFromGroupByOptionMethod);
            return;
        }

        // Duplicate validation
        if (duplicateTimeRecordIds.length > 0) {
            this.showValidation(duplicateTimeRecordIds, Constants.TIMECARD_IS_DUPLICATE, isFromGroupByOptionMethod, false);
            return;
        }

        // St greater than 10 validation
        if (isSTHoursGreaterThanTen && !isFromGroupByOptionMethod) {
            MessageBox(Constants.ST_HOURS_CANNOT_BE_GREATER, Constants.ERROR);
            return;
        }

        if (isAllowAttestation) {
            // Timecard not attested validation
            if (notAttestedTimeRecordIds.length > 0) {
                this.showValidation(notAttestedTimeRecordIds, Constants.TIMECARDS_CANNOT_BE_SUBMITTED_SINCE_ATTESTATION_IS_MISSING, isFromGroupByOptionMethod, false);
                return;
            }

            // Attestation rejected validation
            if (rejectedAttestationEmployeeList.length > 0 && !isFromGroupByOptionMethod) {
                this.setState({ rejectedAttestationEmployeeList, isRejectedAttestation: true });
                return;
            }
        }

        return true;
    }

    submitTimeCard() {
        if (!this.validateTimeCardSubmit()) {
            return;
        }
        this.onClickSubmit();
    }

    async openAttestation(empId) {
        const { timeRecords } = this.state;
        const timeRecord = timeRecords.find(a => a.employeeID === empId);
        const timeCardList = timeRecord.timecardData[0];
        const { totalStHours, totalOtHours, totalDtHours } = timeRecord;
        const attestTimeCardIds = timeRecord.timecardData.map(a => a.timeRecordID);

        const attestTimeCardDetails = {
            stHours: utility.getFormatedTotalHours(totalStHours),
            otHours: utility.getFormatedTotalHours(totalOtHours),
            dtHours: utility.getFormatedTotalHours(totalDtHours),
            employeeName: `${timeCardList.employeeNumber} - ${timeCardList.fullName}`,
            employeeNumber: timeCardList.employeeNumber,
            startTime: timeCardList.startTime,
            endTime: timeCardList.endTime,
            lunchStartTime: timeCardList.lunchStartTime,
            lunchEndTime: timeCardList.lunchEndTime,
            createdDate: timeCardList.createdDate,
            attestTimeCardIds: attestTimeCardIds,
        };
        this.props.history.push("Attestation", { empId, timeRecords, attestTimeCardDetails });
    }

    render() {
        const { timeRecords, selectedDate, selectedPayRollNote, isOpenPayRollNotes, isOpenActualNotes, isOpenExceptationalNotes, isAttachmentModelVisible, isShowActualModalLoading, selectedAttachment, weekStartDate, weekEndingDate, isOpenTimeCardReview, isGroupByModelVisible, defaultGroupBy, payRollNoteListOptions,
            isShowPayRollNoteSaveConfimation, selectedExpectationsNote, isShowExpectationNoteSaveConfimation, selectedActualNote, isShowActualNoteSaveConfirmation, issueNotesCount, isIssueNoteModalVisible, selectedIssueNotes, projectList, isDeleteConfirmationPopupVisible, isDeleteIconClicked, selectedTimeRecordsForDelete, isShowLoader,
            isSubmitConfirmationModelVisible, isSubmitConfirmationMessage, submittedTimeRecordCount, submittedIssueNoteCount, isSubmitModelVisible, isSubmitIssueNoteModelVisible, isIssueNoteVisible, isShowIssueNoteSaveConfirmation, isSaveIssueNoteButtonDisabled, statusCodeDataList, dailyDetailsCount, isDatePickerOpen, isShowTMVoucher, tmTaskCodeList, selectedTMVoucher,
            tmVouchersCount, tmVoucherConfirmMessage, timeCardSubmittedMessage, issueNoteSubmittedMessage, isTMVoucherSubmitted, rejectedAttestationEmployeeList, isShowAttestationErrorModal, attestErrorValidationMessage, isAllowAttestation, validationTimeRecordIdsWithTypes, isRejectedAttestation, isActualNoteSaveBtnDisabled } = this.state;
        return (
            <Fragment>
                <TimeCardComponent
                    {...{
                        timeCard: {
                            timeRecords,
                            selectedDate,
                            selectedPayRollNote,
                            isOpenPayRollNotes,
                            isOpenActualNotes,
                            isOpenExceptationalNotes,
                            isAttachmentModelVisible,
                            selectedAttachment,
                            isShowActualModalLoading,
                            weekStartDate,
                            weekEndingDate,
                            isOpenTimeCardReview,
                            isGroupByModelVisible,
                            defaultGroupBy,
                            payRollNoteListOptions,
                            isShowPayRollNoteSaveConfimation,
                            selectedExpectationsNote,
                            isShowExpectationNoteSaveConfimation,
                            selectedActualNote,
                            isShowActualNoteSaveConfirmation,
                            isIssueNoteModalVisible,
                            issueNotesCount,
                            selectedIssueNotes,
                            projectList,
                            isDeleteConfirmationPopupVisible,
                            isDeleteIconClicked,
                            selectedTimeRecordsForDelete,
                            isShowLoader,
                            isSubmitConfirmationModelVisible,
                            isSubmitConfirmationMessage,
                            submittedTimeRecordCount,
                            submittedIssueNoteCount,
                            isSubmitModelVisible,
                            isSubmitIssueNoteModelVisible,
                            isIssueNoteVisible,
                            isShowIssueNoteSaveConfirmation,
                            isSaveIssueNoteButtonDisabled,
                            statusCodeDataList,
                            dailyDetailsCount,
                            isDatePickerOpen,
                            isShowTMVoucher,
                            tmTaskCodeList,
                            selectedTMVoucher,
                            tmVouchersCount,
                            tmVoucherConfirmMessage,
                            timeCardSubmittedMessage,
                            issueNoteSubmittedMessage,
                            isTMVoucherSubmitted,

                            rejectedAttestationEmployeeList,
                            isShowAttestationErrorModal,
                            attestErrorValidationMessage,
                            isAllowAttestation,
                            validationTimeRecordIdsWithTypes,
                            isRejectedAttestation,
                            isActualNoteSaveBtnDisabled
                        }
                    }}
                    getTimeCardIssue={this.getTimeCardIssue.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    closeIssueNotes={this.closeIssueNotes.bind(this)}
                    onClickEdit={this.onClickEdit.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                    onClickTimeCardReview={this.onClickTimeCardReview.bind(this)}
                    onCloseTimeCardReview={this.onCloseTimeCardReview.bind(this)}
                    onClickGrpByModel={this.onClickGrpByModel.bind(this)}
                    onCloseGrpByModel={this.onCloseGrpByModel.bind(this)}
                    onChangeGroupByOption={this.onChangeGroupByOption.bind(this)}
                    onClickAddTimeCard={this.onClickAddTimeCard.bind(this)}
                    onClickLogout={this.onClickLogout.bind(this)}
                    handlePayRollNoteChange={this.handlePayRollNoteChange.bind(this)}
                    handlePayRollNoteTextChange={this.handlePayRollNoteTextChange.bind(this)}
                    savePayRollNote={this.savePayRollNote.bind(this)}
                    onClickPayRollNoteBack={this.onClickPayRollNoteBack.bind(this)}
                    onClosePayRollModel={this.onClosePayRollModel.bind(this)}
                    handleExpectationUnitChange={this.handleExpectationUnitChange.bind(this)}
                    handleExpectationNoteChange={this.handleExpectationNoteChange.bind(this)}
                    saveExpectationNote={this.saveExpectationNote.bind(this)}
                    onClickExpectationNoteBack={this.onClickExpectationNoteBack.bind(this)}
                    onCloseExpectationNoteModel={this.onCloseExpectationNoteModel.bind(this)}
                    onClickActualNoteBack={this.onClickActualNoteBack.bind(this)}
                    onCloseActualNoteModel={this.onCloseActualNoteModel.bind(this)}
                    saveActualNote={this.saveActualNote.bind(this)}
                    handleActualUnitChange={this.handleActualUnitChange.bind(this)}
                    handleActualNoteChange={this.handleActualNoteChange.bind(this)}
                    onChangeActulNoteAttachment={this.onChangeActulNoteAttachment.bind(this)}
                    onActualNoteAttachmentRemove={this.onActualNoteAttachmentRemove.bind(this)}
                    onClickAddIssueNote={this.onClickAddIssueNote.bind(this)}
                    onRemoveIssueNotes={this.onRemoveIssueNotes.bind(this)}
                    onChangeIssueNoteAttachment={this.onChangeIssueNoteAttachment.bind(this)}
                    onSaveIssueNotesModel={this.onSaveIssueNotesModel.bind(this)}
                    onChangeIssueNotesProjectDropDown={this.onChangeIssueNotesProjectDropDown.bind(this)}
                    removeIssueNotesAttachment={this.removeIssueNotesAttachment.bind(this)}
                    onClickDeleteIcon={this.onClickDeleteIcon.bind(this)}
                    onChangeWorkDoneAtJobSite={this.onChangeWorkDoneAtJobSite.bind(this)}
                    onCancelDeletePopup={this.onCancelDeletePopup.bind(this)}
                    onSelectedTimeCard={this.onSelectedTimeCard.bind(this)}
                    onCancelCheckBox={this.onCancelCheckBox.bind(this)}
                    deleteTimeCard={this.deleteTimeCard.bind(this)}
                    onClickCurrentWeekTimeCard={this.onClickCurrentWeekTimeCard.bind(this)}
                    onClickPreviousWeekTimeCard={this.onClickPreviousWeekTimeCard.bind(this)}
                    onClickSubmit={this.onClickSubmit.bind(this)}
                    closeSubmitConfirmationModal={this.closeSubmitConfirmationModal.bind(this)}
                    onClickSync={this.onClickSync.bind(this)}
                    closeSubmitModel={this.closeSubmitModel.bind(this)}
                    closeIssueNotesSubmitModel={this.closeIssueNotesSubmitModel.bind(this)}
                    onClickSubmittedTimeCardPage={this.onClickSubmittedTimeCardPage.bind(this)}
                    onClickDeleteButton={this.onClickDeleteButton.bind(this)}
                    onClickStartAndLunchTime={this.onClickStartAndLunchTime.bind(this)}
                    onClickIssueNotesBack={this.onClickIssueNotesBack.bind(this)}
                    getStatusCodeList={this.getStatusCodeList.bind(this)}
                    onClickDailyDetails={this.onClickDailyDetails.bind(this)}
                    onChangeStatusCode={this.onChangeStatusCode.bind(this)}
                    onClickHelp={this.onClickHelp.bind(this)}
                    handleDatePickerOpenAndClose={this.handleDatePickerOpenAndClose.bind(this)}
                    onSyncButton={this.onSyncButton.bind(this)}
                    onClickTMVoucherBtn={this.onClickTMVoucherBtn.bind(this)}
                    onClickTMVoucherBackBtn={this.onClickTMVoucherBackBtn.bind(this)}
                    onChangeSelectTaskCode={this.onChangeSelectTaskCode.bind(this)}
                    onClickSelectBtn={this.onClickSelectBtn.bind(this)}
                    openAttestation={this.openAttestation.bind(this)}
                    submitTimeCard={this.submitTimeCard.bind(this)}
                    openOrCloseAttestationModals={this.openOrCloseAttestationModals.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
        date: state.dateReducer.date,
        groupBy: state.defaultGroupByReducer.groupBy
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions, dateActions, timeCardActions, onDefaultGroupByAction, onHistorySaveAction, tmVoucherAction),
        dispatch);
}

TimeCard.displayName = 'TimeCard';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TimeCard));